import { styled } from '@mui/material/styles';
import { Stack } from '@mui/material';

export const ActionStack = styled(Stack)`
  gap: ${({ theme }) => theme.spacing(3)};
  flex-direction: row;
  align-items: center;
  height: 100%;
`;
